import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { PercentualLoyalty } from '../../../../../typings'
import styles from '../styles'
import { ReviewProps } from './constants'
import { messages } from './messages'

type Props = ReviewProps & {
  config: PercentualLoyalty
}

export function PercentualLoyaltyReview(props: Props) {
  const { config } = props
  const { formatPercentual } = useNumbers()

  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.percentualLoyalty}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
          b: (content) => <Text variant="body">{content}</Text>,
          discount: formatPercentual(config.value),
        }}
      />
    </SummaryRow.Value>
  )
}
